function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "calls-contacts-mid_svg__a",
  "data-name": "Addressbook_ic_mid",
  viewBox: "0 0 192 192"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 26,
  width: 140,
  height: 148,
  rx: 12,
  ry: 12,
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Pfad>",
  cx: 86,
  cy: 82,
  r: 18,
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M116 136c-3.23-21.89-16.61-36-29.82-36S59.24 114.11 56 136",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M138 174V28M138 62h28M138 100h28M138 138h28"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "ICON"
}, /*#__PURE__*/React.createElement("use", {
  "data-name": "Addressbook_ic_mid",
  width: 192,
  height: 192,
  xlinkHref: "#calls-contacts-mid_svg__a"
}));

var SvgCallsContactsMid = function SvgCallsContactsMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgCallsContactsMid;